/* Presentation adapter. The existing studio owns design state and all editing actions. */
(() => {
  const paths = {
    templates: '<rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/>',
    stickers: '<path d="m12 2 3 6.3 7 .9-5.1 4.9 1.3 7L12 17.8l-6.2 3.3 1.3-7L2 9.2l7-.9Z"/>',
    photo: '<path d="M8 5 9.5 3h5L16 5h4a2 2 0 0 1 2 2v12H2V7a2 2 0 0 1 2-2Z"/><circle cx="12" cy="12" r="4"/>',
    text: '<path d="M4 6V3h16v3M12 3v18M8 21h8"/>',
    background: '<rect x="3" y="3" width="18" height="18" rx="1"/><path d="m3 13 10-10M3 20 17 6m-7 15L21 10m-4 11 4-4"/>',
    layers: '<path d="m12 3 10 6-10 6L2 9Zm-9 11 9 6 9-6M3 18l9 5 9-5"/>',
    more: '<circle cx="4" cy="12" r="1"/><circle cx="12" cy="12" r="1"/><circle cx="20" cy="12" r="1"/>',
    cart: '<path d="M2 3h3l3 13h11l3-10H6"/><circle cx="9" cy="21" r="1"/><circle cx="18" cy="21" r="1"/>',
    search: '<circle cx="10" cy="10" r="7"/><path d="m15 15 7 7"/>',
    account: '<circle cx="12" cy="7" r="4"/><path d="M3 21v-3c0-6 18-6 18 0v3Z"/>',
    menu: '<path d="M3 5h18M3 12h18M3 19h18"/>',
    fit: '<path d="M8 3H3v5m13-5h5v5M3 16v5h5m13-5v5h-5"/><rect x="8" y="6" width="8" height="12" rx="1"/>',
    arrow: '<path d="M3 12h18m-6-6 6 6-6 6"/>',
    edit: '<path d="m4 16-1 5 5-1L21 7l-4-4ZM14 6l4 4"/>',
  };
  const icon = name => `<svg viewBox="0 0 24 24" aria-hidden="true">${paths[name === 'export' ? 'arrow' : name] || paths.more}</svg>`;
  const button = (tool, label, extra = '') => `<button type="button" class="sz-tool ${extra}" data-studio-tool="${tool}" aria-label="${label}" title="${label}">${icon(tool)}<span>${label}</span></button>`;
  const close = '<button type="button" class="sz-sheet-close" data-sheet-close aria-label="Uždaryti skydelį">×</button>';

  class StrayzyStudioUI {
    constructor(studio) {
      this.studio = studio;
      this.root = studio.root;
      this.mobile = window.matchMedia('(max-width: 1100px)');
      this.tool = 'stickers';
      this.libraryTool = 'stickers';
      this.sheetOpen = false;
      this.displayScale = 1;
      this.zoom = 100;
      this.root.classList.add('sz-studio');
      const q = selector => this.root.querySelector(selector);
      this.shell = q('.sticker-studio');
      this.sidebar = q('.studio-sidebar');
      this.layers = q('.studio-layers');
      this.preview = q('.studio-preview');
      this.canvasWrap = q('.studio-canvas-wrap');
      this.stage = q('.phone-stage');
      const scenery = this.create('div', 'sz-preview-scenery', '');
      scenery.setAttribute('aria-hidden', 'true');
      this.preview.prepend(scenery);
      this.zoomControls = this.create('div', 'sz-zoom', `<div class="sz-zoom-stepper"><button type="button" data-display-zoom="out" aria-label="Mažinti">−</button><output data-display-zoom-value>100%</output><button type="button" data-display-zoom="in" aria-label="Didinti">+</button></div><button type="button" data-display-zoom="center">${icon('fit')}<span>Centruoti</span></button>`);
      this.preview.append(this.zoomControls);
      this.edit = q('[data-tool-panel="edit"]');
      this.layers.append(this.edit, q('.studio-footer'));
      this.sidebar.prepend(this.create('div', 'sz-sheet-head', `<span data-sheet-title>LIPDUKAI</span>${close}`));
      this.layers.prepend(this.create('div', 'sz-sheet-head', `<span>SLUOKSNIAI</span>${close}`));
      const model = q('.sidebar-model-field');
      q('.studio-topbar').prepend(model);
      q('.sidebar-sticky-tools').remove();
      q('.studio-title').hidden = true;
      q('.sticker-library-panel h2').textContent = 'Lipdukai';
      q('[data-sticker-search]').placeholder = 'Ieškoti lipdukų…';
      q('.edit-panel h2').textContent = 'Redaguoti';
      q('[data-trigger-photo-upload]').after(this.create('button', 'studio-button sz-my-photos', 'Mano įkelti failai'));
      q('.sz-my-photos').type = 'button'; q('.sz-my-photos').dataset.myPhotos = '';
      q('.studio-topbar').append(this.create('button', 'sz-mobile-layers', `${icon('layers')}`));
      q('.sz-mobile-layers').type = 'button';
      q('.sz-mobile-layers').dataset.studioTool = 'layers';
      q('.sz-mobile-layers').setAttribute('aria-label', 'Sluoksniai ir redagavimas');
      this.shell.prepend(this.create('nav', 'sz-tool-rail',
        button('background', 'Fonas') + button('stickers', 'Lipdukai') + button('text', 'Tekstai') + button('photo', 'Foto') + button('templates', 'Šablonai') +
        '<span class="sz-rail-motto">TAVO<br>STILIUS.<br>TAVO<br>ISTORIJA.</span><small>STRAYZY<br>CASE STUDIO</small>'));
      q('.sz-tool-rail').setAttribute('aria-label', 'Dizaino įrankiai');
      this.shell.append(this.create('nav', 'sz-bottom-nav', button('background', 'Fonas') + button('stickers', 'Lipdukai') + button('text', 'Tekstai') + button('photo', 'Foto') + button('more', 'Daugiau')));
      q('.sz-bottom-nav').setAttribute('aria-label', 'Dizaino įrankiai');
      this.root.prepend(this.create('header', 'sz-header', `
        <div class="sz-announcement"><span>SUKURK KĄ NORS SAVO</span><span>TAVO DĖKLIUKAS. TAVO TAISYKLĖS. ✦</span></div>
        <div class="sz-header-main">
          <button type="button" class="sz-icon sz-menu-toggle" data-store-menu aria-label="Atidaryti meniu" aria-expanded="false">${icon('menu')}</button>
          <a class="sz-logo" href="https://strayzy.com/" aria-label="STRAYZY pradžia"><img src="./assets/strayzy-logo.png?v=1" alt="STRAYZY" width="1110" height="318" /></a>
          <nav class="sz-store-nav" aria-label="Parduotuvė"><a href="https://strayzy.com/collections/all">Parduotuvė</a><a href="https://strayzy.com/pages/kurti-drobe-plakata">Drobės ir plakatai</a><a href="https://strayzy.com/pages/about-us">Apie mus</a><a href="https://strayzy.com/pages/contact">Kontaktai</a></nav>
          <div class="sz-header-actions">
            <a class="sz-icon sz-desktop-only" href="https://strayzy.com/search" aria-label="Paieška">${icon('search')}</a>
            <button class="sz-help sz-desktop-only" type="button" data-studio-tool="help">Pagalba</button>
            <a class="sz-icon sz-desktop-only" href="https://strayzy.com/account" aria-label="Paskyra">${icon('account')}</a>
            <a class="sz-icon" href="https://strayzy.com/cart" aria-label="Krepšelis">${icon('cart')}</a>
            <button class="sz-finish" type="button" data-studio-tool="export"><span class="sz-desktop-label">Įdėti į krepšelį</span><span class="sz-mobile-label">Įdėti į krepšelį</span>${icon('arrow')}</button>
          </div>
        </div>`));
      this.root.querySelectorAll('.sz-header a[href^="https://"]').forEach(link => {
        link.target = '_blank'; link.rel = 'noopener';
      });
      this.more = this.create('div', 'sz-extra-panel', `<h2>Daugiau</h2><div class="sz-more-grid">${button('background', 'Fonas')}${button('layers', 'Sluoksniai')}${button('edit', 'Redaguoti')}${button('export', 'Įdėti į krepšelį')}</div><div class="sz-draft-tools"></div>`);
      this.more.dataset.uiPanel = 'more';
      this.more.hidden = true;
      this.sidebar.append(this.more);
      ['[data-save-draft]', '[data-load-draft]', '[data-reset]'].forEach(selector => q('.sz-draft-tools').append(q(selector)));
      this.help = this.create('div', 'sz-extra-panel', '<h2>Kaip kurti?</h2><p>Pasirink telefono modelį ir pridėk lipdukų, nuotrauką arba tekstą.</p><p>Elementą judink tiesiai ant dėklo. Dydį ir pasukimą keisk rankenėlėmis arba skydelyje „Redaguoti“.</p><p>Sluoksnių rodyklėmis keisk eiliškumą. Akies mygtuku gali paslėpti elementą.</p><p>Baigęs atverk „Įdėti į krepšelį“, patikrink spaudos kokybę ir išsaugok darbą.</p>');
      this.help.hidden = true;
      this.sidebar.append(this.help);
      this.quality = this.create('div', 'sz-quality', '<span class="sz-quality-dot"></span><span data-quality-label></span>');
      this.quality.setAttribute('role', 'status');
      q('.studio-footer').prepend(this.quality);
      this.inspector = this.create('div', 'sz-inspector-scroll', '');
      this.layers.insertBefore(this.inspector, q('.layers-panel'));
      this.inspector.append(q('.layers-panel'), this.edit);
      // Keep inputs for internal editor references while using canvas handles.
      ['[data-size]', '[data-rotation]'].forEach(selector => {
        q(selector).closest('.control-row').hidden = true;
      });
      this.stickerOnlyControls=[q('[data-opacity]').closest('.control-row'),q('.flip-toggle').closest('.control-row'),q('[data-outline-control]')];
      const opacityLabel = q('[data-opacity]').closest('.control-row').querySelector('label');
      opacityLabel.firstChild.textContent = 'Lipduko permatomumas ';
      q('.flip-toggle').closest('.control-row').querySelector('label').textContent = 'Apversti lipduką';
      q('.flip-toggle').setAttribute('aria-label', 'Apversti lipduką');
      q('.flip-toggle').closest('.control-row').after(q('[data-outline-control]'));
      q('[data-outline-control] > label').textContent = 'Lipduko apvadas';
      const withOutline = q('[data-sticker-outline="white"]');
      withOutline.textContent = 'Su apvadu';
      q('[data-sticker-outline="none"]').textContent = 'Be apvado';
      q('.outline-toggle').prepend(withOutline);
      q('.outline-toggle').setAttribute('aria-label', 'Lipduko apvadas');
      q('.edit-panel [data-tool-tab="design"]').textContent = 'Teksto / fono nustatymai';
      const layerList = q('.layer-list');
      this.layerObserver = new MutationObserver(() => this.arrangeLayers());
      this.layerObserver.observe(layerList, {childList: true});
      this.draftHome = q('.sz-draft-tools');
      this.categories = this.create('div', 'sz-sticker-navigation', '<button type="button" class="sz-all-stickers" data-clear-sticker-filter>Visi lipdukai</button>');
      q('.sticker-search').after(this.categories);
      this.categoryDisclosure = this.create('details', 'sz-sticker-categories', '<summary>Kategorijos</summary>');
      this.categoryDisclosure.append(q('[data-category-list]'));
      this.categories.append(this.categoryDisclosure);
      const libraryPanel = q('.sticker-library-panel');
      const libraryHome = document.createComment('sticker library home');
      libraryPanel.before(libraryHome);
      const gallery = this.create('dialog', 'sz-sticker-gallery', '<header><h2>Visi lipdukai</h2><button type="button" data-sticker-gallery-close aria-label="Uždaryti lipdukų galeriją" autofocus>×</button></header><div class="sz-sticker-gallery-body"></div>');
      gallery.setAttribute('aria-label', 'Lipdukų galerija');
      this.root.append(gallery);
      const galleryBody = gallery.querySelector('.sz-sticker-gallery-body');
      const galleryTrigger = this.categories.querySelector('.sz-all-stickers');
      galleryTrigger.setAttribute('aria-haspopup', 'dialog');
      galleryTrigger.addEventListener('click', () => {
        this.categoryDisclosure.open = false;
        if (gallery.open) return;
        galleryBody.append(libraryPanel);
        gallery.showModal();
        if (!this.mobile.matches) q('[data-sticker-search]').focus({preventScroll:true});
      });
      gallery.querySelector('[data-sticker-gallery-close]').addEventListener('click', () => gallery.close());
      gallery.addEventListener('close', () => {
        libraryHome.after(libraryPanel);
        galleryTrigger.focus({preventScroll:true});
      });
      gallery.addEventListener('keydown', event => { if (event.key === 'Escape') event.stopPropagation(); });
      gallery.addEventListener('click', event => {
        if (event.target.closest('[data-add-sticker]') && !event.target.closest('[data-toggle-favorite]')) {
          // Let the existing delegated insertion finish before returning the panel.
          setTimeout(() => { if (gallery.open) gallery.close(); }, 0);
        } else if (event.target === gallery) {
          const r = gallery.getBoundingClientRect();
          if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) gallery.close();
        }
      });
      q('.browse-categories-button').remove();
      const libraryOptions = this.create('details', 'sz-library-options', '<summary>Įkelti savo lipdukus</summary>');
      q('.sticker-library-panel').append(libraryOptions);
      libraryOptions.append(q('.sticker-view-tabs'), q('.library-actions'), q('.studio-clear-custom'));
      this.buildTextTabs();
      this.textPanel = new window.StrayzyTextPanel(this);
      this.backgroundPanel = new window.StrayzyBackgroundPanel(this);
      this.status = q('[data-status]');
      this.status.setAttribute('role', 'status');
      this.statusHome = this.status.parentNode;
      this.root.addEventListener('click', event => this.onClick(event), true);
      document.addEventListener('pointerdown', event => {
        if (event.button !== 0 || !(event.target instanceof Element) || this.studio.activeDrag) return;
        // Keep selection while using an object, its handles, or an editing control.
        if (event.target.closest('.phone-case, [data-uid], .sticker-handle, button, input, select, textarea, label, summary, a, [contenteditable="true"], [role="slider"], .bg-saturation')) return;
        if (this.studio.selectedId || this.studio.backgroundResizeEnabled) this.studio.clearSelection();
      }, true);
      // A handle can move away from the release point. Ignore the resulting canvas
      // click so completing a transform does not immediately deselect the object.
      this.root.addEventListener('pointerdown', event => {
        if (event.target.closest('.sz-layer-menu summary')) { event.stopPropagation(); return; }
        if (event.target.closest('[data-resize-handle], [data-rotate-handle]')) this.handlePointer = {id:event.pointerId,x:event.clientX,y:event.clientY};
        const textNode = event.target.closest('.studio-canvas-wrap [data-uid]');
        if (this.mobile.matches && textNode && !event.target.closest('[data-resize-handle], [data-rotate-handle]') && this.studio.items.find(item=>item.uid===textNode.dataset.uid)?.type==='text') {
          this.textTap = {id:event.pointerId,uid:textNode.dataset.uid,x:event.clientX,y:event.clientY,moved:false};
        }
      }, true);
      window.addEventListener('pointermove', event => {
        if (this.textTap?.id===event.pointerId && Math.hypot(event.clientX-this.textTap.x,event.clientY-this.textTap.y)>8) this.textTap.moved=true;
      }, true);
      window.addEventListener('pointerup', event => {
        if (this.handlePointer?.id === event.pointerId && Math.hypot(event.clientX-this.handlePointer.x,event.clientY-this.handlePointer.y)>3) this.ignoreCanvasClickUntil = performance.now()+150;
        this.handlePointer = null;
        const tap=this.textTap;
        this.textTap=null;
        if (tap?.id===event.pointerId && !tap.moved && Math.hypot(event.clientX-tap.x,event.clientY-tap.y)<=8) {
          queueMicrotask(()=>{ if(this.studio.selectedId===tap.uid) this.openTool('text'); });
        }
      }, true);
      window.addEventListener('pointercancel', () => { this.handlePointer = null; this.textTap=null; });
      this.root.querySelectorAll('.sz-sheet-head').forEach(head => {
        const grip=this.create('button','sz-sheet-grip','<span></span>');
        grip.type='button'; grip.setAttribute('aria-label','Braukite aukštyn arba žemyn'); grip.setAttribute('aria-expanded','false');
        head.prepend(grip);
        grip.addEventListener('pointerdown', event => {
          if (!this.mobile.matches || event.button !== 0) return;
          event.preventDefault();
          const panel=head.parentElement;
          // Capture the visible position before stopping an in-flight snap animation.
          const height=panel.getBoundingClientRect().height;
          const offset=parseFloat(this.root.style.getPropertyValue('--sz-sheet-drag-offset'))||0;
          const interrupted=!!this.sheetFrame;
          cancelAnimationFrame(this.sheetFrame);
          this.sheetFrame=0;
          if(this.root.dataset.sheetSize!=='expanded' && !this.root.dataset.sheetDragging)panel.szCompactHeight=height;
          grip.setPointerCapture(event.pointerId);
          this.sheetPointer={id:event.pointerId,y:event.clientY,height:height-offset,
            compact:panel.szCompactHeight||height,
            max:this.shell.clientHeight-(parseFloat(getComputedStyle(panel).bottom)||0),delta:0,moved:interrupted};
        });
        grip.addEventListener('pointermove', event => {
          const drag=this.sheetPointer;
          if(drag?.id!==event.pointerId)return;
          drag.delta=event.clientY-drag.y;
          if(!drag.moved && Math.abs(drag.delta)<6)return;
          drag.moved=true;
          if(this.sheetFrame)return;
          this.sheetFrame=requestAnimationFrame(()=>{
            this.sheetFrame=0;
            this.paintSheetPosition(Math.max(0,Math.min(drag.max,drag.height-drag.delta)));
          });
        });
        grip.addEventListener('pointerup', event => {
          if(this.sheetPointer?.id===event.pointerId)this.finishSheetGesture(event.clientY-this.sheetPointer.y);
        });
        grip.addEventListener('pointercancel', () => this.finishSheetGesture(0, true));
      });
      this.root.addEventListener('keydown', event => {
        if (event.key === 'Escape') { this.closeSheet(); this.root.classList.remove('sz-menu-open'); }
        if (event.target.matches('[data-text-section]') && ['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) {
          event.preventDefault();
          const current = Number(event.target.dataset.textSection);
          const count = this.textTabs.children.length;
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? count - 1 : (current + (event.key === 'ArrowRight' ? 1 : count - 1)) % count;
          this.showTextSection(String(next)); this.textTabs.children[next].focus();
        }
      });
      this.mobile.addEventListener('change', () => { this.sheetOpen = false; this.sync(); });
      // Keep the sheet inside the visible area when a mobile keyboard pans/resizes it.
      const viewport = () => {
        const page=this.root.closest('.studio-page');
        if(this.mobile.matches && window.visualViewport){
          this.root.style.setProperty('--sz-viewport',window.visualViewport.height+'px');
          page?.style.setProperty('--sz-viewport-top',window.visualViewport.offsetTop+'px');
        }else{
          this.root.style.removeProperty('--sz-viewport');
          page?.style.removeProperty('--sz-viewport-top');
        }
      };
      window.visualViewport?.addEventListener('resize', viewport);
      window.visualViewport?.addEventListener('scroll', viewport);
      this.mobile.addEventListener('change', viewport);
      this.root.addEventListener('focusin',event=>{
        if(this.mobile.matches && this.sheetOpen && event.target.matches('input,textarea,select')){
          this.clearSheetDrag();
          this.setSheetExpanded(true);
          viewport();
        }
      });
      viewport();
      this.resizeObserver = new ResizeObserver(() => this.fitDisplay());
      this.resizeObserver.observe(this.canvasWrap);
      this.resizeObserver.observe(this.stage);
      q('[data-model-photo]').addEventListener('load', () => { this.zoom = 100; this.fitDisplay(); });
      this.steps = new window.StrayzyStudioSteps(this);
    }

    create(tag, className, html) {
      const node = document.createElement(tag); node.className = className; node.innerHTML = html; return node;
    }

    async onClick(event) {
      if (this.mobile.matches && event.target.closest('[data-add-text]')) {
        event.preventDefault(); event.stopImmediatePropagation();
        await this.studio.addText();
        this.root.querySelector(':focus')?.blur();
        this.closeSheet();
        return;
      }
      if (event.target.closest('.sz-layer-menu summary')) { event.stopImmediatePropagation(); return; }
      if (event.target.closest('.studio-canvas-wrap') && performance.now() < (this.ignoreCanvasClickUntil || 0)) {
        this.ignoreCanvasClickUntil = 0; event.preventDefault(); event.stopImmediatePropagation(); return;
      }
      const control = event.target.closest('[data-studio-tool], [data-sheet-close], [data-store-menu], [data-display-zoom], [data-text-section], [data-font-choice], [data-my-photos]');
      if (!control) return;
      event.preventDefault(); event.stopImmediatePropagation();
      if (control.hasAttribute('data-my-photos')) {
        this.openTool('stickers'); this.studio.clearStickerFilter(); this.studio.setStickerView('mine');
        this.root.querySelector('.sz-library-options').open = true; return;
      }
      if (control.hasAttribute('data-text-section')) { this.showTextSection(control.dataset.textSection); return; }
      if (control.hasAttribute('data-font-choice')) {
        const select = this.studio.nodes.textFont;
        select.value = control.dataset.fontChoice; select.dispatchEvent(new Event('change', {bubbles:true}));
        this.syncTextControls(); return;
      }
      if (control.hasAttribute('data-display-zoom')) {
        const action = control.dataset.displayZoom;
        if (action === 'center') {
          const background = this.studio.caseBackground;
          if (background.type !== 'pattern') return;
          if (background.patternOffsetX || background.patternOffsetY || background.patternX !== 50 || background.patternY !== 50) {
            this.studio.pushHistorySnapshot();
            background.patternOffsetX = 0;
            background.patternOffsetY = 0;
            background.patternX = 50;
            background.patternY = 50;
            this.studio.updateCaseBackground();
            this.studio.syncOutput();
          }
          return;
        }
        if (this.tool === 'background' && this.studio.caseBackground.type === 'pattern') {
          const background = this.studio.caseBackground;
          const scale = Math.max(10, Math.min(350, background.patternScale + (action === 'in' ? 10 : -10)));
          if (scale !== background.patternScale) {
            this.studio.pushHistorySnapshot();
            background.patternScale = scale;
            this.studio.backgroundResizeEnabled = true;
            this.studio.updateCaseBackground();
            this.studio.syncOutput();
          }
          this.fitDisplay(); return;
        }
        this.zoom = Math.max(50, Math.min(180, this.zoom + (action === 'in' ? 10 : -10)));
        this.fitDisplay(); return;
      }
      if (control.hasAttribute('data-store-menu')) {
        const open = this.root.classList.toggle('sz-menu-open');
        control.setAttribute('aria-expanded', String(open)); return;
      }
      if (control.hasAttribute('data-sheet-close')) { this.closeSheet(); return; }
      this.lastTrigger = control;
      this.openTool(control.dataset.studioTool);
    }

    openTool(tool) {
      this.clearSheetDrag();
      if (tool === 'export' && this.mobile.matches) {
        this.closeSheet();
        this.root.classList.add('sz-cart-feedback');
        this.studio.saveDesign();
        return;
      }
      this.root.classList.remove('sz-cart-feedback');
      this.tool = tool;
      this.sheetOpen = true;
      if(this.mobile.matches)this.setSheetExpanded(false);
      if (['model', 'templates', 'stickers', 'photo', 'text', 'background', 'export', 'help', 'more'].includes(tool)) this.libraryTool = tool;
      this.explicitTool = true;
      this.studio.setToolPanel(['text', 'background'].includes(tool) ? 'design' : ['model', 'layers', 'more', 'help'].includes(tool) ? 'edit' : tool);
      // Commit the requested panel even when the core panel was already active.
      if (tool === 'model') this.sync();
      this.explicitTool = false;
      this.sidebar.scrollTop = 0;
      if(this.mobile.matches){
        const panel=['layers','edit'].includes(tool)?this.layers:this.sidebar;
        if(panel)panel.szCompactHeight=panel.getBoundingClientRect().height;
        this.setSheetExpanded(true);
      }
    }

    closeSheet() {
      this.clearSheetDrag();
      this.setSheetExpanded(false);
      this.sheetOpen = false;
      this.root.dataset.sheet = 'closed';
      this.lastTrigger?.focus({ preventScroll: true });
      this.fitDisplay();
    }

    paintSheetDrag(height,offset) {
      this.root.dataset.sheetDragging='true';
      this.root.style.setProperty('--sz-sheet-drag-height',height+'px');
      this.root.style.setProperty('--sz-sheet-drag-offset',offset+'px');
    }

    paintSheetPosition(position) {
      // Keep a small panel body while its last pixels slide beneath the toolbar.
      this.paintSheetDrag(Math.max(64,position),Math.max(0,64-position));
    }

    finishSheetGesture(delta,cancelled=false) {
      const drag=this.sheetPointer;
      if(!drag)return;
      cancelAnimationFrame(this.sheetFrame);
      this.sheetFrame=0;
      this.sheetPointer=null;
      if(!drag.moved){this.clearSheetDrag();return;}
      const position=Math.max(0,Math.min(drag.max,drag.height-(cancelled?drag.delta:delta)));
      // Settle by distance to the three stops, never just by swipe direction.
      const stops=[0,drag.compact,drag.max];
      const target=cancelled?drag.height:stops.reduce((best,stop)=>Math.abs(stop-position)<Math.abs(best-position)?stop:best,stops[0]);
      const duration=matchMedia('(prefers-reduced-motion: reduce)').matches?0:180;
      const start=performance.now();
      this.paintSheetPosition(position);
      const settle=now=>{
        const progress=duration?Math.min(1,(now-start)/duration):1;
        const eased=1-Math.pow(1-progress,3);
        this.paintSheetPosition(position+(target-position)*eased);
        if(progress<1){this.sheetFrame=requestAnimationFrame(settle);return;}
        this.setSheetExpanded(target===drag.max);
        if(target===0)this.closeSheet();
        else this.clearSheetDrag();
      };
      this.sheetFrame=requestAnimationFrame(settle);
    }

    clearSheetDrag() {
      cancelAnimationFrame(this.sheetFrame);
      this.sheetFrame=0;
      this.sheetPointer=null;
      delete this.root.dataset.sheetDragging;
      this.root.style.removeProperty('--sz-sheet-drag-height');
      this.root.style.removeProperty('--sz-sheet-drag-offset');
    }

    setSheetExpanded(expanded) {
      this.root.dataset.sheetSize=expanded?'expanded':'compact';
      this.root.querySelectorAll('.sz-sheet-grip').forEach(button=>button.setAttribute('aria-expanded',String(expanded)));
      this.fitDisplay();
    }

    sync() {
      const studio = this.studio;
      if (!studio.nodes) return;
      if (!this.explicitTool && studio.activeToolPanel === 'edit') {
        if (studio.selected?.type === 'text' && (this.tool !== 'model' || this.lastSelected !== studio.selectedId)) {
          this.tool = 'text'; this.libraryTool = 'text';
          if (!this.mobile.matches && this.lastSelected !== studio.selectedId) { this.sheetOpen = true; this.sidebar.scrollTop = 0; }
        } else if (this.lastSelected !== studio.selectedId) {
          this.sheetOpen = false;
          this.tool = this.libraryTool;
        }
      } else if (!this.explicitTool && ['templates', 'stickers', 'photo', 'export'].includes(studio.activeToolPanel)) {
        this.tool = studio.activeToolPanel; this.libraryTool = this.tool;
      } else if (!this.explicitTool && studio.activeToolPanel === 'design' && !['text', 'background'].includes(this.tool)) {
        this.tool = studio.selected?.type === 'text' ? 'text' : 'background'; this.libraryTool = this.tool;
      }
      this.lastSelected = studio.selectedId;
      const statusTarget = this.mobile.matches ? this.root : this.statusHome;
      if (this.status.parentNode !== statusTarget) statusTarget.append(this.status);
      const panelTool = ['edit', 'layers'].includes(this.tool) ? this.libraryTool : this.tool;
      const panel = ['text', 'background'].includes(panelTool) ? 'design' : panelTool;
      this.root.dataset.tool = panelTool;
      this.root.dataset.sheet = this.sheetOpen ? (['edit', 'layers'].includes(this.tool) ? 'layers' : 'tools') : 'closed';
      studio.nodes.toolPanels.forEach(node => {
        const active = node === this.edit || node.dataset.toolPanel === panel;
        node.hidden = !active; node.classList.toggle('is-active', active);
      });
      this.more.hidden = panelTool !== 'more';
      this.help.hidden = panelTool !== 'help';
      const titles = {model:'Modelis', stickers:'Lipdukai', templates:'Šablonai', photo:'Foto', text:'Tekstas', background:'Fonas', export:'Įdėti į krepšelį', more:'Daugiau', help:'Pagalba'};
      this.root.querySelector('[data-sheet-title]').textContent = titles[panelTool] || 'Įrankiai';
      this.root.querySelectorAll('.sz-tool').forEach(node => {
        const active = node.dataset.studioTool === this.tool;
        node.classList.toggle('is-active', active); node.setAttribute('aria-pressed', String(active));
      });
      const draftTarget = this.draftHome;
      ['[data-save-draft]', '[data-load-draft]', '[data-reset]'].forEach(selector => {
        const node = this.root.querySelector(selector);
        if (node.parentNode !== draftTarget) draftTarget.append(node);
      });
      this.updateQuality();
      this.syncCategories();
      this.syncTextControls();
      this.updateSelectionControls();
      this.steps?.sync();
      requestAnimationFrame(() => { if (!studio.activeDrag) this.fitDisplay(); });
    }

    updateSelectionControls() {
      const photo=this.studio.isCustomerPhotoItem(this.studio.selected);
      this.stickerOnlyControls.forEach(row=>{
        if(photo)row.style.setProperty('display','none','important');
        else row.style.removeProperty('display');
      });
    }

    arrangeLayers() {
      this.root.querySelectorAll('.layer-item:not([data-arranged])').forEach(row => {
        row.dataset.arranged = '';
        const actions = row.querySelector('.layer-actions');
        const eye = actions?.querySelector('[data-layer-hide]');
        if (eye) {
          eye.innerHTML = `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z" fill="currentColor"/><circle cx="12" cy="12" r="3" fill="white"/><circle cx="12" cy="12" r="1.5" fill="currentColor"/>${row.classList.contains('is-hidden') ? '<path d="m3 3 18 18" stroke="white" stroke-width="4"/><path d="m3 3 18 18" stroke="currentColor" stroke-width="2"/>' : ''}</svg>`;
          row.prepend(eye);
        }
        else row.prepend(this.create('span', 'sz-layer-fixed', '◉'));
        const uid = row.querySelector('[data-select-layer]')?.dataset.selectLayer;
        const item = this.studio.items.find(item => item.uid === uid);
        const subtitle = row.querySelector('.layer-text small');
        if (subtitle) subtitle.textContent = item?.type === 'text' ? 'Tekstas' : item?.type === 'photo' ? 'Nuotrauka' : row.classList.contains('is-background') ? 'Fonas' : 'Lipdukas';
        const remove = actions?.querySelector('[data-layer-delete], [data-clear-background-layer]');
        if (remove) {
          remove.classList.add('sz-layer-delete');
          const label = row.classList.contains('is-background') ? 'Pašalinti foną' : `Ištrinti sluoksnį: ${this.studio.getItemLabel(item)}`;
          remove.setAttribute('aria-label', label);
          remove.title = label;
          remove.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13M10 10v7m4-7v7"/></svg>';
          row.append(remove);
        }
        if (!actions || row.classList.contains('is-background')) return;
        const menu = this.create('details', 'sz-layer-menu', '<summary aria-label="Sluoksnio veiksmai" title="Sluoksnio veiksmai">≡</summary>');
        row.insertBefore(menu, remove || actions);
        menu.append(actions);
      });
    }

    syncCategories() {
      const button = this.categories.querySelector('.sz-all-stickers');
      const active = this.studio.activeStickerCategory === 'All' && this.studio.stickerView === 'browse' && !this.studio.stickerSearch;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    }

    buildTextTabs() {
      const panel = this.root.querySelector('.text-panel');
      const q = selector => panel.querySelector(selector);
      q('textarea').rows = 2;
      q('textarea').setAttribute('aria-label', 'Tavo tekstas');
      this.textTabs = this.create('div', 'sz-text-tabs', ['Šriftas','Stilius'].map((label,index) => `<button type="button" data-text-section="${index}" role="tab" aria-selected="${index === 0}">${label}</button>`).join(''));
      this.textTabs.setAttribute('role', 'tablist');
      this.textTabs.setAttribute('aria-label', 'Teksto nustatymai');
      q('textarea').after(this.textTabs);
      const groups = Array.from({length:4}, (_,index) => {
        const node = this.create('div', 'sz-text-section', '');
        node.dataset.textSectionPanel = index; node.setAttribute('role', 'tabpanel');
        panel.append(node); return node;
      });
      const fontSelect = q('[data-text-font]');
      const fontGrid = this.create('div', 'sz-font-grid', '');
      const preferred = ['Arial', 'Bebas', 'Oswald', 'Permanent', 'Caveat', 'Montserrat'];
      preferred.forEach(name => {
        const option = [...fontSelect.options].find(item => item.value.includes(name));
        if (!option) return;
        const choice = this.create('button', '', ''); choice.type = 'button'; choice.textContent = option.textContent;
        choice.dataset.fontChoice = option.value; choice.style.setProperty('font-family', option.value, 'important');
        fontGrid.append(choice);
      });
      groups[0].append(fontGrid, fontSelect);
      groups[1].append(q('.text-preset-grid'), q('.effect-preview-grid'));
      const format = q('.text-format-row');
      const align = this.create('div', 'text-format-row', '');
      format.querySelectorAll('[data-text-align]').forEach(node => align.append(node));
      groups[1].append(format); groups[3].append(align);
      const add = q('[data-add-text]');
      const tools = q('.text-tools-row');
      groups[2].append(tools, q('.swatch-row'));
      this.textSize = this.create('label', 'sz-text-size', '<span>Teksto dydis <output>72</output></span><input type="range" min="12" max="500" value="72" aria-label="Teksto dydis" />');
      this.textSize.querySelector('input').addEventListener('input', event => {
        if(this.studio.selected?.type !== 'text'){ (this.studio.textExtras ||= {}).size = Number(event.target.value); this.syncTextControls(); return; }
        const original = this.studio.nodes.size; original.value = event.target.value;
        original.dispatchEvent(new Event('input', {bubbles:true})); this.syncTextControls();
      });
      const entry = this.create('div', 'sz-text-entry', '');
      const textarea = q('textarea');
      textarea.before(entry);
      entry.append(textarea, add);
      entry.after(this.textSize);
      this.showTextSection('0');
    }

    showTextSection(section) {
      this.textTabs.querySelectorAll('button').forEach(button => {
        const active = button.dataset.textSection === section;
        button.setAttribute('aria-selected', String(active)); button.tabIndex = active ? 0 : -1;
      });
      this.root.querySelectorAll('[data-text-section-panel]').forEach(panel => { panel.hidden = panel.dataset.textSectionPanel !== section; });
      this.textPanel?.show(section);
    }

    syncTextControls() {
      if (!this.studio.nodes) return;
      this.textPanel?.sync();
      const item = this.studio.selected;
      this.textSize.hidden = false;
      this.textSize.querySelector('input').disabled = !!item?.locked;
      if(item?.type !== 'text') this.textSize.querySelector('input').value = this.studio.textExtras?.size || 46;
      if (item?.type === 'text') {
        this.textSize.querySelector('input').value = item.size;
        this.textSize.querySelector('output').textContent = Math.round(item.size);
      }
      this.root.querySelectorAll('[data-font-choice]').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.fontChoice === this.studio.textFont));
      });
    }

    // Screen magnification lives outside the design. Geometry consumers use layoutRect;
    // pointer-to-percent dragging still reads the actual, magnified screen rectangle.
    layoutRect(node) {
      if (!node) return null;
      // Read layout dimensions directly, avoiding floating-point drift from a CSS
      // transform matrix. Browser layout uses 1/64px precision, before magnification.
      const style = getComputedStyle(node);
      return { width: Math.round((parseFloat(style.width) || 0) * 64) / 64, height: Math.round((parseFloat(style.height) || 0) * 64) / 64 };
    }

    fitDisplay() {
      if (!this.studio.nodes) return;
      const width = this.stage.offsetWidth, height = this.stage.offsetHeight;
      if (!width || !height) return;
      // Fit the whole model image into the preview row. Print-safe bounds are not
      // the physical phone outline and must not determine the preview's size.
      const fit = Math.min((this.canvasWrap.clientWidth - 36) / width, (this.canvasWrap.clientHeight - 28) / height);
      this.displayScale = Math.max(.1, fit) * 1.08 * this.zoom / 100;
      this.stage.style.transform = `scale(${this.displayScale})`;
      if (this.mobile.matches && this.sheetOpen && this.tool === 'text' && this.studio.selected?.type === 'text') {
        const node = this.studio.nodes.layer.querySelector('.is-selected');
        const sheetTop = this.sidebar.getBoundingClientRect().top;
        const canvasTop = this.canvasWrap.getBoundingClientRect().top;
        if (node && sheetTop > canvasTop + 60) {
          let rect = node.getBoundingClientRect();
          const roomWidth = this.canvasWrap.clientWidth - 40;
          const roomHeight = sheetTop - canvasTop - 48;
          const fitSelection = Math.min(1, roomWidth / Math.max(1,rect.width), roomHeight / Math.max(1,rect.height));
          this.displayScale *= fitSelection;
          this.stage.style.transform = `scale(${this.displayScale})`;
          rect = node.getBoundingClientRect();
          const target = canvasTop + (sheetTop - canvasTop) / 2;
          const shift = Math.min(0, target - (rect.top + rect.height / 2));
          const canvas = this.canvasWrap.getBoundingClientRect();
          const shiftX = canvas.left + canvas.width / 2 - (rect.left + rect.width / 2);
          this.stage.style.transform = `translate(${shiftX}px,${shift}px) scale(${this.displayScale})`;
        }
      }
      this.syncZoomControls();
    }

    syncZoomControls() {
      this.zoomControls.querySelector('[data-display-zoom="center"]').disabled = this.studio.caseBackground.type !== 'pattern';
      const editsBackground = this.tool === 'background' && this.studio.caseBackground.type === 'pattern';
      const value = editsBackground ? this.studio.caseBackground.patternScale : this.zoom;
      this.zoomControls.querySelector('output').textContent = `${editsBackground ? 'Fonas' : 'Peržiūra'} ${value}%`;
      for (const action of ['out', 'in']) {
        const button = this.zoomControls.querySelector(`[data-display-zoom="${action}"]`);
        button.disabled = action === 'out' ? value <= (editsBackground ? 10 : 50) : value >= (editsBackground ? 350 : 180);
        button.setAttribute('aria-label', `${action === 'out' ? 'Mažinti' : 'Didinti'} ${editsBackground ? 'fono paveikslėlį' : 'telefono peržiūrą'}`);
      }
    }

    updateQuality(existingReport) {
      if (!this.studio.nodes) return;
      const report = existingReport || this.studio.getPrintQualityReport();
      const labels = {safe:'Puiki', warning:'Patikrink nuotraukas', 'low-quality':'Per maža raiška'};
      this.quality.dataset.state = report.state;
      this.quality.querySelector('[data-quality-label]').textContent = this.studio.items.length || this.studio.hasCaseBackgroundLayer()
        ? `Spaudos kokybė: ${labels[report.state]}` : 'Pridėk elementų ir pradėk kurti';
      this.quality.title = this.studio.printQualitySummary(report);
    }
  }
  window.StrayzyStudioUI = StrayzyStudioUI;
})();
